import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title, ChartDataLabels);

// Sample data
const labels = [
  "OTHER",
  "VoIP",
  "UTS-PRS",
  "SDH&PDH",
  "MTRC System",
  "SIP Exchange",
  "Auto Exchange",
  "DTMF",
  "FMS",
  "VHF-SET",
  "RAILNET",
  "SPT",
  "ETSR",
  "Quad Cable ",
  "Magneto",
  "IPIS System",
];
const counts = [90, 11, 8, 51, 67, 62, 48, 55, 49, 89, 32, 44, 27, 43, 99, 52]; // Alarm counts

// Compute highest count + 10 for y-axis max
const maxCount = Math.max(...counts) + 10;

// Normalize counts for opacity
const max = Math.max(...counts);
const normalizedOpacities = counts.map((count) => count / max);

const data = {
  labels,
  datasets: [
    {
      label: "Alarm Count",
      data: counts,
      backgroundColor: normalizedOpacities.map((opacity) => `rgba(0, 123, 255, ${opacity})`), // Blue with dynamic opacity
      borderColor: "rgba(0, 123, 255, 1)",
      borderWidth: 0,
    },
  ],
};

const options = {
  plugins: {
    legend: { display: false },
    datalabels: {
      anchor: "end",
      align: "end",
      color: "#000",
      font: {
        weight: "bold",
      },
      formatter: (value) => value,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      max: maxCount,
      ticks: {
        stepSize: 10,
      },
    },
  },
};

export default function AlarmBarChart() {
  return <Bar height={"100%"} data={data} options={options} />;
}
